import '@hapana/shared/utils/type-defs.util'
/** @type {Styles} */

export const styles = {
  signatureDialogContent: {
    padding: 3,
    height: 284,
  },
  signatureContainer: {
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: 'gray.8',
    height: '100%',
  },
  signatureCanvas: { display: 'block' },
}
